import { forwardRef } from 'react';

import { cn } from '@/lib/utils';

const Input = forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-10 px-3 py-2 w-full',
        'bg-background border border-input ring-offset-background rounded-md disabled:cursor-not-allowed disabled:opacity-50',
        'text-base placeholder:text-muted-foreground md:text-sm',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-ring',
        'file:bg-transparent file:border-0 file:font-medium file:text-foreground file:text-sm',
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Input.displayName = 'Input';

export { Input };
